<template>
  <div>
    <template v-if="feePrice">
      <br>Listing Fee: {{ feePrice }}
    </template>
    <template v-if="shippingPrice">
      <br>Logistic Fee: {{ shippingPrice }}
    </template>
    <template v-if="totalPrice">
      <br>Total Fees: {{ totalPrice }}
    </template>
    <template v-if="fee.payment">
      <br><strong class="text-success">Paid:</strong> {{ paidAt }}
      <template v-if="fee.payment.payment_method === 'auth_net'">
        <br>Payment Method: Authorize.Net
        <br>Card: {{ fee.payment.card.brand }} ending in {{ fee.payment.card.ending }}
        <br>Transaction ID: {{ fee.payment.transaction_id }}
        <br>Auth Code: {{ fee.payment.auth_code }}
        <br>Response Code: {{ fee.payment.response_code }}
      </template>
    </template>
    <template v-else>
      <br><strong class="text-danger">Not Paid</strong>
    </template>
  </div>
</template>

<script>
import {convertFromUtc, getFormattedPrice} from "../helpers";

export default {
  name: "AdminListingFeeInfo",
  props: {
    fee: {
      type: Object,
      required: true
    }
  },
  computed: {
    shippingPrice() {
      if (!this.fee.shipping_price) {
        return "";
      }
      return getFormattedPrice(this.fee.shipping_price);
    },
    feePrice() {
      if (!this.fee.total_fee_amount) {
        return "";
      }
      return getFormattedPrice(this.fee.total_fee_amount);
    },
    totalPrice() {
      if (!this.fee.total_to_pay) {
        return "";
      }
      return getFormattedPrice(this.fee.total_to_pay);
    },
    paidAt() {
      if (!this.fee.payment.paid_at) {
        return "";
      }
      return convertFromUtc(this.fee.payment.paid_at, "MM/DD/YYYY HH:mm A");
    }
  }
}
</script>
